module.exports = __webpack_public_path__ + "12_hair_silver.b716da4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/12_hair_silver.png
// module id = tlls
// module chunks = 0